import { B9_FORM_INITIAL_VALUES as B9_FORM_INITIAL_VALUES_SHARED } from 'shared'

export const B9_FORM_INITIAL_VALUES = B9_FORM_INITIAL_VALUES_SHARED

export const B9NavOptions = [
  {
    label:
      'a) způsob zajištění varování a informování obyvatelstva ...',
    target: 'b9.citizenAlertSystem',
  },
  {
    label: 'b) způsob zajištění ukrytí obyvatelstva',
    target: 'b9.populationShelter',
  },
  {
    label:
      'c) způsob zajištění ochrany před nebezpečnými účinky ...',
    target: 'b9.protectionAgainstSubstances',
  },
  {
    label: 'd) způsob zajištění ochrany před povodněmi',
    target: 'b9.floodProtection',
  },
  {
    label:
      'e) způsob zajištění soběstačnosti stavby pro případ výpadku ...',
    target: 'b9.buildingSelfSufficiency',
  },
  {
    label:
      'f) způsob zajištění ochrany stávajících staveb civilní ochrany v území ...',
    target: 'b9.civilProtection',
  },
]
